<template>
  <div>
    <b-card>
      <b-row class="align-items-center">
        <b-col class="radio">
          <b-form-radio-group
            id="radio-group-1"
            v-model="card"
            class="ml-1 list item-view-radio-group"
            buttons
            size="sm"
            button-variant="outline-primary"
          >
            <b-form-radio
              v-for="option in itemViewOptions"
              :key="option.value"
              :value="option.value"
            >
              <feather-icon :icon="option.icon" size="18" />
            </b-form-radio>
          </b-form-radio-group>
        </b-col>

        <b-col v-if="card" class="col-lg-2 col-md-3 col-8">
          <AppSearchInput
            :placeholder="$t('search')"
            :mb0="mb0"
            @callback="search"
          />
        </b-col>
      </b-row>
    </b-card>

    <div v-if="!isLoading">
      <cardContact v-if="!card" />
    
      <tableContact v-if="card" />
    </div>

    <b-card v-else>
      <Loader />
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BFormRadioGroup, BFormRadio } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import cardContact from "./card.vue";
import tableContact from "./table.vue";
import AppSearchInput from "@/components/AppSearchInput.vue";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    BCard,
    cardContact,
    tableContact,
    AppSearchInput,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormRadio,
    Loader,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: false,
      mb0: true,
      card: true,
      filtered: {
        search: "",
        page_size: null,
      },
      itemViewOptions: [
        {
          icon: "ListIcon",
          value: true,
        },
        {
          icon: "GridIcon",
          value: false,
        },
      ],
    };
  },

  mixins: [loader],

  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;
    // let pagination = JSON.parse(
    //   window.sessionStorage.getItem("paginationAmount")
    // );
    // if (pagination) {
    //   this.filtered.page_size = pagination.contact;
    //   await this.FETCH_ALL_CONTACTS_LIST({ page: 1, page_size: pagination.contact });
    // } else {
    //   await this.FETCH_ALL_CONTACTS_LIST();
    // }
    this.isLoading = false;
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },

  computed: {
    ...mapGetters("contacts", ["GET_CONTACTS_TABLE_LIST", "GET_CONTACTS_TABLE_LIST2"]),

    tabProvidersOrBuyers: {
      get: function () {
        return this.$store.state.contacts.tabProvidersOrBuyers;
      },
      set: function (newValue) {
        this.$store.commit("contacts/SET_TAB_PROVIDER_OR_BUYER", newValue);
      },
    },

  },
  methods: {
    ...mapActions("contacts", ["FETCH_ALL_CONTACTS_LIST", "FETCH_ALL_CONTACTS_LIST2"]),


    
    async search(text) {
      this.filtered.search = text;
      if(this.tabProvidersOrBuyers == 0){
        await this.FETCH_ALL_CONTACTS_LIST({...this.filtered,  type: "provider"});
      }else if(this.tabProvidersOrBuyers == 1){
        await this.FETCH_ALL_CONTACTS_LIST2({...this.filtered,  type: "buyer"});
      }
    },



  },
};
</script>
<style>
.radio .btn-sm,
[dir] .btn-group-sm > .btn {
  padding: 9px 12px !important;
}
</style>
